/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FreeText/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function FreeText({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/Templates/Content/Referral/Value/FreeText",
  isInvalid,
  onChange
  
}) {
let newReferralTextValueValueData = fromData.useDataValue({ viewPath,
context: 'new_referral',
path: 'text_value',
})
let newReferralTextValueIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_referral',
path: 'text_value',
validate: fromValidate.textInput,
required: true,
})
let newReferralTextValueChangeData = fromData.useDataChange({ viewPath,
context: 'new_referral',
path: 'text_value',
})
  return (<React.Fragment
>
<div
  data-testid="FreeText.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 size="medium"
 marginTop={0}
 data="new_referral.text_value"
 validate="/Data/validate.js textInput"
 required={true}
 invalid={!newReferralTextValueIsValidData}
 value={newReferralTextValueValueData}
 onChange={newReferralTextValueChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="What else?"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}